<script setup>
import { ref, onMounted, onUnmounted, inject, watch} from 'vue'
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
import { satService } from '@requests/Main/sat.service'
import { useConfirm } from 'primevue/useconfirm'
const toast = inject('toast')
// Автосохранение подключаем после загрузки данных, чтобы открытие вкладки не вызывало PUT
let stopAutoSave = null
onMounted(async () => {
  experiment.value = wpStore.experiment
  stopAutoSave = watch(() => experiment.value.Sat, () => debouncedSave(), {deep: true})
})
onUnmounted(() => {
  stopAutoSave?.()
  debouncedSave.flush()
})
const TableInfo = ref({mode: 0,
  param:[
    {name:'semiMajorAxis', header:'Большая полуось', type:'number', digits: 5},
    {name:'eccentricity', header:'Эксцентриситет', type:'number', digits: 5},
    {name:'inclination', header:'Наклон', type:'number', digits: 5},
    {name:'raan', header:'Долгота восходящего угла', type:'number', digits: 5},
    {name:'argPerigee', header:'Аргумент широты перигея', type:'number', digits: 5},
    {name:'trueAnomaly', header:'Истинная аномалия', type:'number', digits: 5},
  ]
})

const SaveSat = async () => {
  let data = await satService.PutSat(experiment.value.Sat)
  return data
  
}
const AddReactionWheels = () => {
  experiment.value.Sat.config.reactionWheels.push({axisX: 0, axisY: 0, axisZ: 0, maxAngularMomentum: 0, maxTorque: 0})
}
const AddStarSensors = () => {
  experiment.value.Sat.config.starSensors.push({angleErrorX: 0,angleErrorY: 0,angleErrorZ: 0,measurementCycle: 0,orientationX: 0,orientationY: 0,orientationZ: 0})
}
const AddAngularRateSensors = () => {
    experiment.value.Sat.config.angularRateSensors.push({biasInterval: 0,biasStability: 0, measurementCycle: 0,noise: 0,orientationX: 0,orientationY: 0,orientationZ: 0,randomWalk: 0,scaleFactor: 0})
}
// Удаление сразу уходит на сервер через автосохранение — спрашиваем подтверждение
const confirm = useConfirm()
const ConfirmDelete = (event, key, index, name) => {
  confirm.require({
    target: event.currentTarget,
    message: `Удалить ${name} № ${index + 1}?`,
    icon: 'pi pi-exclamation-triangle',
    rejectProps: {label: 'Отмена', severity: 'secondary', outlined: true},
    acceptProps: {label: 'Удалить', severity: 'danger'},
    accept: () => experiment.value.Sat.config[key].splice(index, 1),
  })
}

import Select from 'primevue/select';
const experiment = ref({Sat: null,Tar:null})
import Fieldset from 'primevue/fieldset';
import { debounce } from 'lodash-es'

const debouncedSave = debounce(() => {
  SaveSat()
}, 500)

const imagingSensor = [{name: "ОЭС", value:"OES"}, {name: "РЛС", value:"RLS"},{name: "РТС", value:"RTS"}]
</script>

<template>
<section v-if="experiment.Sat" class="SectionPanel">
<Fieldset legend="Информация">
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputText v-model="experiment.Sat.name" size="small" style="width: 100%;"/>
        <label>Название</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputText v-model="experiment.Sat.createdAt" size="small" style="width: 100%;" disabled/>
        <label>Дата создания</label>
      </FloatLabel>
    </div>
</Fieldset>

<Fieldset legend="Орбитальное построение">
    <div v-for="data,index in TableInfo.param" :key="index" class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.orbit[data.name]" :maxFractionDigits="data.digits" size="small" style="width: 100%;"/>
        <label :for="'input_'+index">{{data.header}}</label>
      </FloatLabel>
    </div>
</Fieldset>

<Fieldset legend="Съёмочное оборудование">
    <div class="fieldsetDiv">
      <Select v-model="experiment.Sat.config.imagingSensor.type" :options="imagingSensor" optionLabel="name" optionValue="value"/>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'OES'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.fieldOfView" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Угол обзора</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'OES'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.maxAllowedShootingAngle" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Допустимый угол съемки</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'RLS'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.afarBeamControlPitch" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>afarBeamControlPitch</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'RLS'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.afarBeamControlRoll" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>afarBeamControlRoll</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'RLS'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.shootingAngleRangeMax" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>shootingAngleRangeMax</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv" v-if="experiment.Sat.config.imagingSensor.type == 'RLS'">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.imagingSensor.shootingAngleRangeMin" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>shootingAngleRangeMin</label>
      </FloatLabel>
    </div>
</Fieldset>

<Fieldset legend="Параметры">
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.mass" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Масса</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.agile.acceleration" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Ускорение/замедление</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.agile.speed" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Скорость</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Sat.config.agile.stabilizationTime" :maxFractionDigits="5" size="small" style="width: 100%;"/>
        <label>Время стабилизации</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv Tenzor">
      <p>Тензор инерции</p>
      <table>
        <tr v-for="rdata, rindex in experiment.Sat.config.inertiaTensor" :key="rindex">
          <td><InputNumber  v-model="rdata[0]" :maxFractionDigits="5" size="small" style="width: 100%;"/></td>
          <td><InputNumber  v-model="rdata[1]" :maxFractionDigits="5" size="small" style="width: 100%;"/></td>
          <td><InputNumber  v-model="rdata[2]" :maxFractionDigits="5" size="small" style="width: 100%;"/></td>
        </tr>
      </table>
    </div>
</Fieldset>
</section>
<section v-if="experiment.Sat" class="SectionPanel" style="flex-direction: column;">
<Fieldset legend="Маховики">
    <table class="FieldsetTable">
        <tbody>
            <tr class="ElementHeader">
                <th></th>
                <td v-for="data, index in experiment.Sat.config.reactionWheels" :key="index">
                    <div class="ElementTitle">
                        <span>№ {{ index + 1 }}</span>
                        <Button icon="pi pi-times" rounded text severity="secondary" size="small" class="ElementDelete" aria-label="Удалить"
                          @click="ConfirmDelete($event, 'reactionWheels', index, 'маховик')"/>
                    </div>
                </td>
                <td :rowspan="4" class="ElementAddCell">
                    <Button icon="pi pi-plus" label="Добавить" severity="secondary" variant="outlined" class="ElementAdd" @click="AddReactionWheels"/>
                </td>
            </tr>
            <tr>
                <th>Max Управляющий момент</th>
                <td v-for="data, index in experiment.Sat.config.reactionWheels" :key="index"><InputNumber  v-model="data.maxTorque" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Max Кинетический момент</th>
                <td v-for="data, index in experiment.Sat.config.reactionWheels" :key="index"><InputNumber  v-model="data.maxAngularMomentum" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Ориентация вектора маховика</th>
                <td v-for="data, index in experiment.Sat.config.reactionWheels" :key="index">
                    <div style="display: flex;gap: 5px;justify-content: center;">
                        <InputNumber  v-model="data.axisX" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                        <InputNumber  v-model="data.axisY" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                        <InputNumber  v-model="data.axisZ" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</Fieldset>

<Fieldset legend="Звёздные датчики">
<table class="FieldsetTable">
    <tbody>
        <tr class="ElementHeader">
            <th></th>
            <td v-for="data, index in experiment.Sat.config.starSensors" :key="index">
                <div class="ElementTitle">
                    <span>№ {{ index + 1 }}</span>
                    <Button icon="pi pi-times" rounded text severity="secondary" size="small" class="ElementDelete" aria-label="Удалить"
                      @click="ConfirmDelete($event, 'starSensors', index, 'звёздный датчик')"/>
                </div>
            </td>
            <td :rowspan="4" class="ElementAddCell">
                <Button icon="pi pi-plus" label="Добавить" severity="secondary" variant="outlined" class="ElementAdd" @click="AddStarSensors"/>
            </td>
        </tr>
        <tr>
            <th>Такт измерения</th>
            <td v-for="data, index in experiment.Sat.config.starSensors" :key="index"><InputNumber  v-model="data.measurementCycle" size="small" :maxFractionDigits="5" style="width: 100%"/></td>
        </tr>
        <tr>
            <th>Ориентация вектора маховика</th>
            <td v-for="data, index in experiment.Sat.config.starSensors" :key="index">
                <div style="display: flex;gap: 5px;justify-content: center;">
                    <InputNumber  v-model="data.orientationX" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    <InputNumber  v-model="data.orientationY" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    <InputNumber  v-model="data.orientationZ" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                </div>
            </td>
        </tr>
        <tr>
            <th>Погрешности измерений</th>
            <td v-for="data, index in experiment.Sat.config.starSensors" :key="index">
                <div style="display: flex;gap: 5px;justify-content: center;">
                    <InputNumber  v-model="data.angleErrorX" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    <InputNumber  v-model="data.angleErrorY" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    <InputNumber  v-model="data.angleErrorZ" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                </div>
            </td>
        </tr>
    </tbody>
</table>
</Fieldset>

<Fieldset legend="Датчики угловой скорости">
    <table class="FieldsetTable">
        <tbody>
            <tr class="ElementHeader">
                <th></th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index">
                    <div class="ElementTitle">
                        <span>№ {{ index + 1 }}</span>
                        <Button icon="pi pi-times" rounded text severity="secondary" size="small" class="ElementDelete" aria-label="Удалить"
                          @click="ConfirmDelete($event, 'angularRateSensors', index, 'датчик угловой скорости')"/>
                    </div>
                </td>
                <td :rowspan="7" class="ElementAddCell">
                    <Button icon="pi pi-plus" label="Добавить" severity="secondary" variant="outlined" class="ElementAdd" @click="AddAngularRateSensors"/>
                </td>
            </tr>
            <tr>
                <th>Масштабный коэффициент</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index"><InputNumber  v-model="data.scaleFactor" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Случайное блуждание угла</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index"><InputNumber  v-model="data.randomWalk"  :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Стабильность смещения</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index"><InputNumber  v-model="data.biasStability" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Шум</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index"><InputNumber  v-model="data.noise" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Такт измерения</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index"><InputNumber  v-model="data.measurementCycle" :maxFractionDigits="5" size="small" style="width: 100%"/></td>
            </tr>
            <tr>
                <th>Ориентация вектора измерения</th>
                <td v-for="data, index in experiment.Sat.config.angularRateSensors" :key="index">
                    <div style="display: flex;gap: 5px;justify-content: center;">
                        <InputNumber  v-model="data.orientationX" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                        <InputNumber  v-model="data.orientationY" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                        <InputNumber  v-model="data.orientationZ" :maxFractionDigits="5" size="small" style="flex: 1;" class="smallInput"/>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</Fieldset>
</section>
</template>

<style>
.p-splitterpanel .ToolbarPanel{
    border: none;
    border-bottom: 1px solid var(--p-toolbar-border-color);
    border-radius: 0px;
    padding: 5px;
    position: sticky;
    top: 0px;
    z-index: 5;
}
.fieldsetDiv{
  flex: 1;
}
.fieldsetDiv.Tenzor{
    display: flex;
    flex-direction: column;
    position: relative;
}
.fieldsetDiv.Tenzor p{
    position: absolute;
    top: -15px;
    width: 100%;
    margin: 0px;
    margin: 0px;
    color: var(--p-floatlabel-active-color);
    font-size: var(--p-floatlabel-active-font-size);
    font-weight: var(--p-floatlabel-active-font-weight);
}
.fieldsetDiv.Tenzor input{
    width: 50px;
}
.input-150 input{
    width: 150px;
}
.p-splitterpanel .SectionPanel{
    display: flex;
    flex-wrap: wrap;
}
.SectionPanel .p-fieldset .p-fieldset-content{
    display: flex;
    gap: 20px;
    flex-direction: column;
}
.SectionPanel .FieldsetTable th{
    color: var(--p-floatlabel-active-color);
    font-size: var(--p-floatlabel-active-font-size);
    font-weight: var(--p-floatlabel-active-font-weight);
    text-align: start;
}
.smallInput input{
  width: 50px;
}
.ElementHeader td{
  padding-bottom: 2px;
}
.ElementTitle{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: var(--p-floatlabel-active-font-size);
  font-weight: 600;
  color: var(--p-text-muted-color);
}
.ElementDelete.p-button{
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
}
.ElementDelete.p-button:hover{
  color: var(--p-red-500);
  background: color-mix(in srgb, var(--p-red-500) 12%, transparent);
}
.ElementAddCell{
  height: 1px; /* чтобы кнопка могла растянуться на всю высоту ячейки */
  vertical-align: top;
  padding-left: 8px;
}
.ElementAdd.p-button{
  height: 100%;
  min-height: 60px;
  flex-direction: column;
  gap: 4px;
  border-style: dashed;
  color: var(--p-text-muted-color);
}
.ElementAdd.p-button:hover{
  color: var(--p-primary-color);
  border-color: var(--p-primary-color);
}
</style>